import 'css-chunksrc/client/scenes/strategicAxisEdition/styles.scss';export default {
  "strategicAxisEdition": "_strategicAxisEdition_1umrx_1",
  "main": "_main_1umrx_5",
  "footer": "_footer_1umrx_14",
  "button": "_button_1umrx_22"
};